import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const HERO_IMG = "https://images.pexels.com/photos/11053643/pexels-photo-11053643.jpeg";

export const Hero = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="home" className="relative min-h-[100svh] flex items-center overflow-hidden grain">
      <img
        src={HERO_IMG}
        alt="Prime mover heavy transport truck at night"
        fetchpriority="high"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-ink-900 via-ink-900/80 to-ink-900/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-transparent to-ink-900/40" />

      <div className="relative z-10 mx-auto max-w-7xl px-5 md:px-8 pt-28 pb-20 w-full">
        <motion.span
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
          className="overline inline-flex items-center gap-2"
        >
          <span className="h-px w-8 bg-orange" /> Premium Signage · Australia Wide
        </motion.span>

        <motion.h1
          initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-5 font-head font-black uppercase leading-[0.95] tracking-tight text-4xl sm:text-6xl lg:text-7xl max-w-4xl"
        >
          Built to be <span className="text-orange">Seen.</span>
          <span className="block mt-2 text-2xl sm:text-3xl lg:text-4xl text-white/90 font-extrabold">
            Premium Signage for Australia's Transport & Construction Industry.
          </span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.25 }}
          className="mt-6 text-white/70 text-base md:text-lg max-w-2xl leading-relaxed"
        >
          Specialising in end tipper trailers, commercial fleets, heavy vehicles and
          large-format building signage.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.4 }}
          className="mt-9 flex flex-col sm:flex-row gap-4"
        >
          <button
            data-testid="hero-quote-btn"
            onClick={() => go("quote")}
            className="group flex items-center justify-center gap-2 bg-orange hover:bg-orange-hover text-white font-head font-bold uppercase tracking-wide px-8 py-4 transition-colors"
          >
            Get a Free Quote
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <button
            data-testid="hero-work-btn"
            onClick={() => go("portfolio")}
            className="flex items-center justify-center gap-2 border border-orange text-orange hover:bg-orange/10 font-head font-bold uppercase tracking-wide px-8 py-4 transition-colors"
          >
            View Our Work
          </button>
        </motion.div>
      </div>
    </section>
  );
};
